const getTranslation = (
  translationKey: string,
  translations: unknown,
  ...replacementValues: Array<string | number>
) => {
  if (!translationKey || typeof translationKey !== 'string') {
    return '';
  }

  const translationsIsObject =
    typeof translations === 'object' &&
    translations !== null &&
    !Array.isArray(translations);

  const translationIsValid =
    translationsIsObject &&
    translationKey in translations &&
    typeof (translations as Record<string, unknown>)[translationKey] === 'string';

  if (!translationIsValid) {
    return translationKey;
  }

  let translation = (translations as Record<string, string>)[translationKey];

  if (replacementValues?.length) {
    replacementValues.forEach((value, index) => {
      if (typeof value === 'string' || typeof value === 'number') {
        translation = translation.split(`{${index}}`).join(String(value));
      }
    });
  }

  return translation;
};

export default getTranslation;
